import { TextField } from '@warp-ds/react/components/textfield';
import { useState } from 'react';
import { BasicDatePicker } from 'shared/components/basicDatePicker/BasicDatePicker';
import { addDays, addMonths, safeDifferenceInCalendarDays, subDays } from 'shared/util/datetime-fns';
import { FlexibleDateHandler } from '@/components/filters/travelTime/FlexibleDateHandler';
import type { LmsDateRange, LmsFilters } from '@/interfaces/lms';
import displayValues from '@/resources/displayValues.json';

type LmsDatePickerProps = {
    filters: LmsFilters;
    updateFilters: (key: string, value: LmsDateRange | undefined) => void;
};

const calculateFlexibility = (dateRange: LmsDateRange | undefined): number => {
    const diff = safeDifferenceInCalendarDays(dateRange?.from, dateRange?.to);
    return diff ? Math.ceil(diff / 2) : 0;
};

export const LmsDateFilter = ({ filters, updateFilters }: LmsDatePickerProps) => {
    const flexibility: number = calculateFlexibility(filters.avreise);
    const date: Date | null = filters.avreise ? addDays(flexibility, filters.avreise.from) : null;

    const [selectedFlex, setSelectedFlex] = useState<number>(flexibility);
    const [selectedDate, setSelectedDate] = useState<Date | null>(date);

    const updateDateFilter = (date: Date | null, flexibility: number) => {
        updateFilters('avreise', date ? { from: subDays(flexibility, date), to: addDays(flexibility, date) } : undefined);
    };

    const handleDateChange = ({ startDate }: { startDate: Date | null }): void => {
        setSelectedDate(startDate);
        updateDateFilter(startDate, selectedFlex);
    };
    const handleFlexibilityChange = (flex: string): void => {
        setSelectedFlex(~~flex);
        updateDateFilter(selectedDate, ~~flex);
    };

    return (
        <>
            <BasicDatePicker
                onDateChange={handleDateChange}
                startDate={selectedDate}
                useRange={false}
                visibleMonths={1}
                upperDateLimit={addMonths(2, new Date())}>
                <TextField id="departureDate" label="Avreisedato" />
            </BasicDatePicker>
            <FlexibleDateHandler options={displayValues.flexibilityOptions} selected={selectedFlex} onChange={handleFlexibilityChange} />
        </>
    );
};
